        <template>
  <div
      >
    <b-row
          >
                                    <b-col
                                                                                                >
                            <news-detail />            </b-col>
                            </b-row>
  </div>
</template>
<script>
/* eslint-disable */
// prettier-ignore
import {
  BRow,
  BCol,
} from 'bootstrap-vue'


                                      import NewsDetail from '@core/components/news-and-documents/news/news-detail/NewsDetail.vue'
                            
export default {
  components: {
    BRow,
    BCol,

                                                          NewsDetail,
                                          },
  setup() {
    
      },
}
</script>
    